export default __webpack_public_path__ + "static/media/1300.81b34931.png";